import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import {
    CardActions,
    CardContent,
    Grid,
    MenuItem,
    TextField
} from '@material-ui/core';
import { Cancel, Edit, Save } from '@material-ui/icons';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    currentContest: {
        textAlign: 'center',
        fontSize: 36,
        color: theme.palette.primary.main,
        display: 'block',
        marginBottom: theme.spacing(2),
    },
    contestSelection: {
        width: '100%',
        maxWidth: 450, // keeps it nice on desktop
    },
    input: {
        color: 'white',
    },
    cssLabel: {
        '&$cssFocused': {
            color: 'white',
        },
    },
    cssOutlinedInput: {
        '&$cssFocused $notchedOutline': {
            borderColor: 'white',
        },
    },
    cssFocused: {},
    notchedOutline: {
        borderColor: 'white',
    },
});

class CurrentContest extends Component {
    state = {
        currentContestEdit: false,
        currentContest: 0,
    };

    componentDidMount() {
        this.getContestDetails();
        this.getTeamDetails();
    }

    getContestDetails() {
        this.props.dispatch({
            type: 'FETCH_CURRENT_CONTEST',
            payload: this.props.user,
        });

        this.props.dispatch({
            type: 'FETCH_ALL_CONTESTS',
            payload: this.props.user,
        });
    }

    getTeamDetails() {
        this.props.dispatch({
            type: 'FETCH_TEAM_DETAILS',
        });
    }

    toggleCurrentContestEdit = () => {
        this.setState(prevState => ({
            currentContestEdit: !prevState.currentContestEdit,
        }));
    };

    handleChangeFor = propertyName => event => {
        this.setState({
            [propertyName]: event.target.value,
        });
    };

    handleCurrentContestSave = () => {
        this.props.dispatch({
            type: 'UPDATE_CURRENT_CONTEST',
            payload: this.state,
        });
        this.toggleCurrentContestEdit();
    };

    render() {
        const { classes } = this.props;

        return (
            <div>
                <CardContent>
                    <h2>Current Contest</h2>
                    <span className={classes.currentContest}>
                        {this.props.currentContest.contest_name}
                    </span>

                    {this.state.currentContestEdit && (
                        <Grid container>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    select
                                    label="Current Contest"
                                    className={classes.contestSelection}
                                    value={this.state.currentContest}
                                    onChange={this.handleChangeFor('currentContest')}
                                    margin="normal"
                                    variant="outlined"
                                    InputProps={{
                                        className: classes.input,
                                        classes: {
                                            root: classes.cssOutlinedInput,
                                            focused: classes.cssFocused,
                                            notchedOutline: classes.notchedOutline,
                                        },
                                    }}
                                    InputLabelProps={{
                                        className: classes.input,
                                        shrink: true,
                                    }}
                                >
                                    {this.props.allContests.map((contest, i) => (
                                        <MenuItem key={i} value={contest.id}>
                                            {contest.contest_name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        </Grid>
                    )}
                </CardContent>

                <CardActions
                    style={{
                        justifyContent: 'flex-start',
                        padding: '8px 16px 16px',
                        marginLeft: -24,
                        marginRight: -24,
                        marginBottom: -24,
                        width: 'calc(100% + 48px)',
                    }}
                >
                    {!this.state.currentContestEdit &&
                        this.props.user.clearance_id > 1 && (
                            <Button
                                color="secondary"
                                variant="outlined"
                                onClick={this.toggleCurrentContestEdit}
                                style={{ marginRight: 20 }}
                            >
                                <Edit style={{ marginRight: 3 }} />
                                Edit
                            </Button>
                        )}

                    {this.state.currentContestEdit &&
                        this.props.user.clearance_id > 1 && (
                            <Button
                                color="secondary"
                                variant="outlined"
                                onClick={this.toggleCurrentContestEdit}
                                style={{ marginRight: 20 }}
                            >
                                <Cancel style={{ marginRight: 3 }} />
                                Cancel
                            </Button>
                        )}

                    {this.state.currentContestEdit &&
                        this.props.user.clearance_id > 1 && (
                            <Button
                                onClick={this.handleCurrentContestSave}
                                style={{
                                    marginLeft: 'auto',
                                    color: this.props.user.color,
                                }}
                            >
                                <Save style={{ marginRight: 3 }} />
                                Save
                            </Button>
                        )}
                </CardActions>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
    currentContest: state.currentContest,
    allContests: state.allContests,
    team: state.team,
});

export default withRouter(
    connect(mapStateToProps)(withStyles(styles)(CurrentContest))
);
